import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 37 38"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#222120",
  "fill-rule": "evenodd",
  d: "M21 32.333h5.833v-15H21zm-10.833 0H16v-15h-5.833zm26.666-15v-5h-5.115C30.897 5.758 25.298.667 18.5.667S6.103 5.758 5.282 12.333H.167v5h5v15h-5v5h36.666v-5h-5v-15z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render() { return h(NuxtIcon, {icon: {render}}) } }